import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';

export const ListItemDrawer = styled(Drawer, {
  '.abyss-modal-base-body': {
    borderTop: '1px solid $core.color.neutral.30',
    color: '$neutralGray',
    '.abyss-modal-section-root': {
      lineHeight: '20px',
      paddingBottom: '32px',
    },
  },
  '.abyss-modal-close-button': {
    margin: '6px 8px 0 0',
    '.abyss-modal-close-icon': {
      fill: '$core.color.neutral.80',
    },
  },
  '.abyss-modal-header-container': {
    padding: '0 16px 16px',
    '.abyss-modal-content-title': {
      fontSize: '$medium',
      color: '$core.color.brand.100',
      fontFamily: '$primary',
      lineHeight: '24px',
      fontWeight: 'bold',
    },
  },
  '.abyss-modal-base-content-container': {
    height: 'auto !important',
    borderRadius: '20px 20px 0 0',
  },
});
